import { Component, ElementRef, OnChanges, OnInit } from '@angular/core';
import { BaseRenderComponent } from 'cms/workspace/workspace-generic-classes/base-render.component';
import { IdtSharedRenderService } from 'render/render-shared/idt-shared-render.service';
import { RenderConfigurationService } from 'render/services/render-configuration.service';
import { Observable } from 'rxjs';
import { AmandaOptions, AssetsSharedService } from 'shared/services/assets-shared.service';
import { Link } from 'shared/services/links.model';

import { PieceCardHoverSettings } from './models/piece-card-hover.models';


@Component({
  selector: 'piece-card-hover-render',
  templateUrl: './piece-card-hover-render.component.html',
  styleUrls: ['./piece-card-hover-render.component.scss']
})

export class PieceCardHoverRenderComponent
  extends BaseRenderComponent<PieceCardHoverSettings>
  implements OnChanges, OnInit {

  public orientation$!: Observable<string>;

  constructor(
    private readonly elRef: ElementRef<HTMLElement>,
    private readonly idtSharedRenderService: IdtSharedRenderService,
    private readonly renderConfigurationService: RenderConfigurationService,
    private readonly assetsSharedService: AssetsSharedService
  ) {
    super();
    this.orientation$ = this.idtSharedRenderService.screenOrientation$;
  }

  public get pieceLink(): Link | null {
    return isDefined(this.settings?.general.link.type)
      ? this.settings?.general.link as Link : null;
  }

  public ngOnInit(): void {
    this.refreshStyles();
    this.orientation$.subscribe((orientation) => {
      const imageSrc = this.getBackgroundImageSrc(orientation);
      this.elRef.nativeElement.style.setProperty('--srcImg', `url('${imageSrc}')`);
    });
  }

  public ngOnChanges(): void {
    this.refreshStyles();
  }

  public getBackgroundImageSrc(orientation: string): string | undefined {
    const assetsUrl = this.renderConfigurationService.config.assetsUrl;
    const image = orientation === 'landscape' ? this.settings?.general.image.imgLandscape.image : this.settings?.general.image.imgPortrait.image;
    const akamaiOptions: AmandaOptions = {
      isWidthParamEnabled: this.renderConfigurationService.config.amandaImageVideoManagerEnabled,
      width: this.assetsSharedService.getWidth(this.elRef)
    };
    return this.assetsSharedService.getAssetUrl(image!, assetsUrl, akamaiOptions);
  }

  private refreshStyles(): void {
    this.elRef.nativeElement.style.setProperty('--srcImg', `url('${this.settings?.general.image.imgLandscape.image}')`);
    this.elRef.nativeElement.style.setProperty('--colorTxtHover', `${this.settings?.general?.colorTxtHover}`);
    this.elRef.nativeElement.style.setProperty('--bgColorBtn', `${this.settings?.general?.bgColorBtn}`);
    this.elRef.nativeElement.style.setProperty('--bgColorBtnHover', `${this.settings?.general?.bgColorBtnHover}`);
  }

}
